import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useEffect, useReducer, useState } from "react";
import Loader from "react-loader-spinner";
import editIcon from '../../assets/edit.png';
import api from "../api";
import MuiAlert from '@material-ui/lab/Alert';
import CloseImage from '../../assets/ic_close.png';
import { useHistory } from "react-router";
import Constant from "../../library/Constant";
import AddMediaDisplay from "./AddMediaDisplay";
import EditMediaDisplay from "./EditMediaDisplay";


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function TableMediaDisplay(props) {
    const history = useHistory()
    const [dataTable, setDataTable] = useState([])
    const [id, setID] = useState("")
    const [visibleCreate, setVisibleCreate] = useState(false)
    const [detail, setDetail] = useState([])
    const [visibleEdit, setVisibleEdit] = useState(false)
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [create, setCreate] = useState(true);
    const [read, setRead] = useState(true);
    const [update, setUpdate] = useState(true);
    const [deleted, setDeleted] = useState(true);
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDataTable = () => {
        api.create().getListMedia().then(response => {
            console.log(response);
            let data = response.data.data.sort((a, b) => b.is_publish - a.is_publish).map((item, index) => {
                return [
                    index + 1,
                    item.title,
                    item.video_url === "" ? 'Foto' : 'Video',
                    item.expired_date,
                    item.is_publish === 1 ? 'Yes' : 'No',
                    item.id,
                ]
            })
            setDataTable(data)
        })
    }

    const handleEdit = ({ rowData }) => {
        console.log(rowData);
        setVisibleEdit(true)
        setID(rowData[5])
    }

    const createMedia = (FormData) => {
        console.log(...FormData);
        api.create().createMedia(FormData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    getDataTable()
                    setVisibleCreate(false)
                } else {
                    if (response.data.data) {
                        setError(true)
                        setErrorMessage(response.data.data)
                    } else {
                        setVisibleCreate(false)
                    }
                }
            }
        })
    }

    const updateMedia = (FormData) => {
        console.log(...FormData);
        api.create().updateMedia(FormData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    getDataTable()
                    setVisibleEdit(false)
                } else {
                    if (response.data.data) {
                        setError(true)
                        setErrorMessage(response.data.data)
                    }
                }
            }
        })
    }

    const handleStatus = ({ rowData }) => {
        setVisibleStatus(true)
        setDetail(rowData)
    }

    const changeStatus = () => {
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                sortThirdClickReset: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            label: "Nama",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Tipe",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Valid To",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Publish",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <LightTooltip title={"Edit"} arrow>
                                <button
                                    onClick={() => {
                                        handleEdit(tableMeta)
                                    }}
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}>
                                    <img src={editIcon} style={{ width: 20, height: 20 }} />
                                </button>
                            </LightTooltip>
                            {/* <div
                                onClick={() => {
                                    localStorage.setItem(Constant.DATA_PROMOSI, tableMeta.rowData[5])
                                    window.open(`/medapp-webadmin/preview-promosi/${tableMeta.rowData[5]}`, "_blank")
                                }}
                                style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', width: 100, borderRadius: 20, backgroundColor: '#2a9c6c', marginLeft: 20, cursor: 'pointer' }}>
                                <Typography style={{ color: 'white', fontWeight: '500', fontFamily: 'Poppins' }}>Preview</Typography>
                            </div> */}
                        </div>
                    )
                }
            }
        }
    ];


    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {create && (
                <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10' }}>
                    <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                        onClick={() => setVisibleCreate(true)}
                    >
                        <div style={{ display: 'flex' }}>
                            <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                            <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah </Typography>
                        </div>
                    </button>
                </div>
            )}
            {read && (
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}

            {visibleCreate && (
                <AddMediaDisplay
                    onClose={() => setVisibleCreate(false)}
                    createMedia={createMedia}
                />
            )}

            {visibleEdit && (
                <EditMediaDisplay
                    onClose={() => setVisibleEdit(false)}
                    id={id}
                    updateMedia={updateMedia}
                />
            )}

            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleStatus(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Media Display tersebut?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleStatus(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {error && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        {/* <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            
                        </div> */}
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>{errorMessage}</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {/* <div
                                    onClick={() => setError(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Ok</Typography>
                                </div> */}
                                <div
                                    onClick={() => setError(false)}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}